export const LOAD_CLUSTERS = 'LOAD_CLUSTERS';

export const loadClusters = clusters => ({
  type: LOAD_CLUSTERS,
  data: clusters,
});
